function showCFPT()
      {
        var cfptBuild = '';

        if (listStimType[trialRow]==1)//images
        {
        for (i = 0; i < listNoStim[trialRow]; i++) {
            cfptBuild += '<li class="ui-state-default" id="item_' + (i+1) + '"><img id="CFPT_' + (i+1) + '" /></li>';
        }
        $('#sortImg').append(cfptBuild);

        for (i = 0; i < listNoStim[trialRow]; i++) {
            document.getElementById('CFPT_'+(i+1)).src = images[i+1][trialRow].src;
            document.getElementById('CFPT_'+(i+1)).width = adjuster * images[i+1][trialRow].width;
            document.getElementById('CFPT_'+(i+1)).height = adjuster * images[i+1][trialRow].height;
        }

        document.getElementById("CFPT").style.top = (canvasHeight/2 - $('#image1').height()/2 - borderImage + verticalShift) + "px";

        }

        else//words
        {
            for (i = 0; i < listNoStim[trialRow]; i++) {
                cfptBuild += '<li class="word" id="item_' + (i+1) + '"></li>';
            }

            $('#sortImg').append(cfptBuild);

            for (i = 0; i < listNoStim[trialRow]; i++) {
                document.getElementById('item_'+(i+1)).innerHTML = listArrays[allColumns.indexOf('stim'+(i+1))][trialRow];
            }

        document.getElementById("CFPT").style.top = (canvasHeight/2 - $('#image1').height()/2 - borderImage + 300) + "px";
        }

        document.getElementById("topRight").style.color = "black";
        document.getElementById("CFPT").style.opacity = "1";

        CFPTcorrectOrder = [];
        CFPTdisplayOrder = [];
        CFPTstartOrderItems = [];
        CFPTstartOrderStim = [];

        for (i = 0; i < listNoStim[trialRow]; i++) {
            CFPTcorrectOrder.push(listArrays[allColumns.indexOf('sort'+(i+1))][trialRow]);
            CFPTdisplayOrder.push(listArrays[allColumns.indexOf('stim'+(i+1))][trialRow]);
            CFPTstartOrderItems.push($('#item_'+(i+1)).index());
        }
        for (i = 0; i < listNoStim[trialRow]; i++) {
            CFPTstartOrderStim.push(CFPTcorrectOrder.indexOf(listArrays[allColumns.indexOf('stim'+(i+1))][trialRow]));
        }

        document.getElementById("CFPT").style.display = "block";

        window.sortCFPT && window.sortCFPT.option('disabled',true);
        window.sortCFPT = Sortable.create(sortImg, {
            animation: 300,
            ghostClass: 'ghost',
        });

        startTimerCFPT(listArrays[allColumns.indexOf('presTime')][trialRow]/1000);
        show("topRight");
        //following line is kept only for back compatibility

        displayText("topLeft",iBlock+"/"+nTrialsBlock[listBlockNo[trialRow]]);//display "trial i of n"

        displayText("leftArrowText",listArrays[allColumns.indexOf('leftArrow')][trialRow]);
        displayText("rightArrowText",listArrays[allColumns.indexOf('rightArrow')][trialRow]);
        document.getElementById("leftArrow").src = "../../../assets/misc/arrowLeft.png";
        document.getElementById("rightArrow").src = "../../../assets/misc/arrowRight.png";
        document.getElementById("leftArrow").style.width = (80*adjuster)+"px";
        document.getElementById("rightArrow").style.width = (80*adjuster)+"px";
        document.getElementById("arrows").style.display="block";
        document.getElementById("arrowsText").style.display="block";
      }